/*
 * File: core.ts
 * File Created: 2024-01-15 03:19:17
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-15 03:30:02
 * Modified By: Val Liu
 * -----
 */

import { DirectiveBinding } from "vue/types/options";

export function getBinding<T extends object>(
    binding: DirectiveBinding,
    defaultOptions: T,
): T {
    return Object.assign(
        defaultOptions, /// default to true
        binding.value,
    ) as T;
}

export function getChildInput(el: HTMLElement): HTMLInputElement | null {
    const input: any =
        el.tagName.toLowerCase() === "input"
            ? el
            : el.querySelector("input") || el.getElementsByTagName("input")[0];
    return input ?? null;
}
